/**
 * A simple cache for functions that take a type and id as parameters.
 * The function is only called once per type/id pair while caching is active.
 * Caching can be started and stopped, and the cache can be cleared.
 *
 * Reason: Form rendering duplicates IO calls for templates and attachments.
 * Currently, they send endpoint requests N times based on the number of reviews and upload elements,
 * and they are spread across multiple elements and files
 * making it difficult to simplify the logic.
 */
export default new (class byTypeAndIdFunctionCacher {
  #cache = new Map();
  #activeCache = false;

  clearCache() {
    this.#cache.clear();
  }

  startCache() {
    this.#activeCache = true;
  }

  stopCache() {
    this.#activeCache = false;
    this.clearCache();
  }

  async getIfCached(type, id, func) {
    let key = `${type}:${id}`;
    if (!this.#activeCache) return func();
    if (this.#cache.has(key)) return this.#cache.get(key);

    const funcPromise = func();
    this.#cache.set(key, funcPromise);
    return funcPromise;
  }
})();
